import React, { useEffect, useRef } from 'react'
import TextDecoration from '../../utility/TextDecoration';
import VizSensor from 'react-visibility-sensor';
import listingService from '../service/listingService';
import styles from './card.module.css'
import { useViewport } from '../../utility/useViewport';


export const BasicVideoHomeCard = (props) => {
    const listing = props.listing;
    const thumb = listing.thumbnailImage ? listing.thumbnailImage : 'assets/Desert.jpg'

    let isViewCounted = false;
    const timeOut = useRef(null);
    const isMobile = useViewport()
    // const runTimer = (infocus) => {
    //     if (!isViewCounted && infocus)
    //         timeOut.current = setTimeout(() => countView(), 5000);
    //     else if (!infocus && timeOut.current)
    //         clearTimeout(timeOut.current)
    // }
    const handleClick = () => {
        !isViewCounted && countView();
        props.showContent(listing)
    }
    const countView = () => {
        timeOut.current && clearTimeout(timeOut.current)
        isViewCounted = true;
        //listingService.updateSingleListingViews(null, listing);
    }
    useEffect(() => {
        return () => timeOut.current && clearTimeout(timeOut.current)
    }, [timeOut])

    return (
        <VizSensor
        // onChange={(isVisible) => {
        //     runTimer(isVisible)
        // }}
        >
            {/* <div key={listing.hpId} className={`col-lg-6 col-xl-4 ${styles.basic_listing_info}`}>
                <div className={`${styles.listing_info_box_basic_home} row form-row curser_hand mx-0`} onClick={handleClick}>
                    <div className="col-4 no_padding">
                        <div className={`${styles.home_thumb_image_basic}`}>
                            <img alt={listing.businessName} className={`img-fluid ${styles.home_thumb_image_basic_img}`} loading='lazy' src={process.env.REACT_APP_IMAGES_URL + thumb} />
                        </div>
                    </div>
                    <div className={`col-8 ${styles.home_Desc}`}>
                        <h3 className={`${styles.home_link}`} >{TextDecoration.ellipsize(listing.businessName, 70)}</h3>
                        
                        <div className={`${styles.basic_home_listing_info_box}`}>
                            {TextDecoration.ellipsize(listing.specializedIn, 100)}
                        </div>
                        <div className={`${styles.basic_home_listing_info_box_desc}`}>
                            <span className={styles.name_span}>By:</span> {listing.subCategories}
                        </div>
                    </div>
                    {(props.viewedContentIds.includes(listing.hpId)) ?
                        <div className="col-md-12">
                            <i className={`fas fa-check-circle ${styles.viewed_mark_home} ${styles.viewed_right_home}`}></i>
                        </div> : null
                    }
                </div>
            </div> */}
            <div className="col-12 col-sm-6 col-lg-4 col-xl-3 col-xxl-2 low_padding ">
                <div className={styles.listing_card_video} onClick={handleClick}>
                    <div className={styles.listing_thumb_img_video}>
                        <img className={`img-fluid ${styles.home_thumb_img_basic_img}`} loading='lazy' src={process.env.REACT_APP_IMAGES_URL + thumb} alt={listing.businessName} />
                        {/* <div className={styles.play_icon_overlay}>
                            <div className={styles.play_icon_circle}>
                                <i className="fas fa-play"></i>
                            </div>
                        </div> */}
                    </div>
                    <div className="listing_details">
                        <h6 className={isMobile ? styles.mob_listing_title_video : styles.listing_title_video}>{TextDecoration.ellipsize(listing.businessName, 65)}</h6>
                        <div className="listing_address">
                            <div className={styles.listing_info_box_desc_newsArt_video}> {TextDecoration.ellipsize(listing.specializedIn, 130)}</div>
                            <div className={styles.basicVideoSubCat}>
                                <span className={`${styles.name_span}`}>By:</span> {TextDecoration.ellipsize(listing.subCategories, 45)}
                            </div>
                        </div>
                        <div className="listing_address">
                            {(props.isViewed) ? <i className="fas fa-check-circle viewed_mark"></i> : null}
                        </div>
                    </div>
                </div>
            </div>
        </VizSensor>
    )
}